import { Div } from '../../../../base/components/native/div'
import { AssistantOption } from './assistant-option'

export const AssistantOptions = () => {

    const base = Div()

    const data = {
        type: [
            { title: 'Digital Painting', image: '/images/o-digital-painting.png' },
            { title: 'Oil painting', image: '/images/o-oil-painting.png' },
            { title: 'Watercolor', image: '/images/o-watercolor.png' },
            { title: 'Cartoon', image: '/images/o-cartoon.png' },
            { title: 'Sketch', image: '/images/o-sketch.png' },
            { title: '3D render', image: '/images/o-3d-render.png' },
            { title: 'Photo', image: '/images/o-photo.png' },
        ],
        feelings: [
            { title: 'Happy', image: '', emoji: '😄'},
            { title: 'Love', image: '', emoji: '😍' },
            { title: 'Inspiration', image: '', emoji: '😊'},
            { title: 'Sadness', image: '', emoji: '😢' },
            { title: 'Anger', image: '', emoji: '😡' },
            { title: 'Joy', image: '', emoji: '😂' },
            { title: 'Fear', image: '', emoji: '😨' },
            { title: 'Surprise', image: '', emoji: '😮' },
            { title: 'Disgust', image: '', emoji: '😖' },
            { title: 'Trust', image: '', emoji: '😌' },
            { title: 'Anticipation', image: '', emoji: '😏' },
            { title: 'Amusement', image: '', emoji: '😆' },
            { title: 'Relief', image: '', emoji: '😌' },
            { title: 'Interest', image: '', emoji: '😮' },

        ]
    }
    function render(type: 'feelings' | 'type') {
        base.empty()
        data[type].forEach((item) => {
            const option = AssistantOption(item.image, item.title, item.emoji)
            option.el.onclick = () => base.emit('select', { title: item.title, type })
            base.append(option)
        })
    }

    base.cssClass({
        backgroundColor: '#ECECEF',
        marginTop: '20px',
        borderRadius: '10px',
        padding: '20px',
        display: 'flex',
        justifyContent: 'start',
        overflow: 'hidden',
        overflowX: 'auto',
        '@media (max-width: 768px)': {
            padding: '10px',
            marginTop: '10px',
        }

    })

    return Object.assign(base, {
        render
    })
    
}